//
// Template store
//

import * as client from 'api/client';
import { introduction as introductionSchema } from 'api/schema';
import { normalize } from 'normalizr';
import { LOGOUT } from './auth';

// ------------------------------------
// Constants
// ------------------------------------

export const NO_TEMPLATE = {
  id: 0,
  title: ''
};

// ------------------------------------
// Action definitions
// ------------------------------------

export const REQUEST_INTRODUCTIONS = 'INTRODUCTIONS/REQUEST';
export const RECEIVE_INTRODUCTIONS = 'INTRODUCTIONS/RECEIVE';

// ------------------------------------
// Actions
// ------------------------------------

export const fetchIntroductions = () => dispatch => {
  dispatch({ type: REQUEST_INTRODUCTIONS });

  return client.get('/api/public/introductions')
    .then(json => {
      const { entities } = normalize(json, [ introductionSchema ]);
      dispatch({
        type: RECEIVE_INTRODUCTIONS,
        introductions: entities.introductions
      });
    })
    .catch(console.error);
};

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  items: {},
  pending: false
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_INTRODUCTIONS:
      return {
        ...state,
        pending: true
      };

    case RECEIVE_INTRODUCTIONS:
      return {
        ...state,
        items: action.introductions,
        pending: false
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

// ------------------------------------
// Utils
// ------------------------------------

export const getAllIntroductions = state => {
  return Object.values(state.introductions.items ? state.introductions.items : {});
};

export const getIntroduction = (state, id) => {
  const { items } = state.introductions;
  return items.hasOwnProperty(id)
    ? { ...items[id] }
    : null;
};



// WEBPACK FOOTER //
// ./src/store/modules/introductions.js